<template>
  <div class="preview-video" v-if="src === ''">No video</div>
  <div class="preview-video" v-else>
    <video
      v-if="engine == 'videojs'"
      ref="videoPlayer"
      class="video-js vjs-default-skin vjs-big-play-centered"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
    ></video>

    <video class="video" v-if="engine == 'video'" 
    :src="src" 
    :poster="poster"
    :controls="controls"
    :muted="muted"
    :autoplay="autoplay"
    :loop="loop"
    :playbackRate="playbackRate"
    @mouseenter="handleMouseEnter" 
    @mouseleave="handleMouseLeave"></video>
  </div>
</template>
<script>
export default {
  name: 'PreviewVideo',
  data() {
    return {
      player: null,
      loading: true,
      videoOptions: {
        // autoplay: "muted", //自动播放
        preload: false,
        autoplay: false,
        playbackRates: [0.5, 1.0, 2.0, 4.0], // 可选的播放速度
        controls: false, //用户可以与之交互的控件
        loop: false, //视频一结束就重新开始
        muted: false, //默认情况下将使所有音频静音
        aspectRatio: '16:9', //显示比率
        poster: '',
        fullscreen: {
          options: { navigationUI: 'hide' },
        },
        sources: [{}],
      },
    }
  },
  props: {
    engine: {
      type: String,
      default: 'videojs', //播放器 videojs、video
    },
    src: {
      type: String,
      require: true,
    },
    //播放倍速
    playbackRate:{
      type: Number,
      default: 1
    },
    hoverPlay: {
      //鼠标悬停自动播放
      type: Boolean,
      default: false,
    },
    leavePause: {
      //鼠标离开自动暂停
      type: Boolean,
      default: false,
    },
    aspectRatio: {
      type: String,
      default: '16:9',
    },
    poster: {
      type: String,
      require: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    controls: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    src: {
      handler(newval) {
        if (this.engine == 'videojs') {
          this.videoOptions.sources[0].src = newval
        }
      },
    },
    playbackRate:{
      handler(newval){
        this.player.ready(function() {
            //速率
            var _this = this
            setTimeout(function() {
                _this.playbackRate(parseFloat(newval));
            },20);
        });
      }
    }
  },
  created() {
    if (this.engine == 'videojs') {
      this.videoOptions.sources[0].src = this.src
      this.videoOptions.poster = this.poster
      this.videoOptions.autoplay = this.autoplay
      this.videoOptions.muted = this.muted
      this.videoOptions.controls = this.controls
      this.videoOptions.loop = this.loop
      this.videoOptions.aspectRatio = this.aspectRatio
      this.videoOptions.playbackRate = this.playbackRate
    }
  },
  mounted() {
    let _this = this
    if (this.engine == 'videojs') {
      //onPlayerReady方法是为了视频播放不了的时候不显示错误的信息
      this.player = this.$video(this.$refs.videoPlayer, this.videoOptions, function onPlayerReady() {
        this.on('error', function () {
          //this.errorDisplay.close_() //将错误信息不显示
        })
        this.on('canplaythrough', function () {
          _this.loading = false
        })
      })
    } else if (this.engine == 'video') {
      this.player = this.$refs.videoPlayer
    }
  },
  methods: {
    handleMouseEnter() {
      if (!this.hoverPlay) return
      if (this.player) {
        this.player.play()
      }
    },
    handleMouseLeave() {
      if (!this.leavePause) return
      if (this.player) {
        this.player.pause()
      }
    },
    // mouseMove(event) {
    //   //这个event是接收父组件传过来的鼠标位置
    //   var videoleft = this.$refs.videoPlayer.getBoundingClientRect().left //video插件距离浏览器左边的距离
    //   var clientx = event.clientX //鼠标距离浏览器左边的距离
    //   var videoWidth = this.$refs.videoPlayer.clientWidth //div总宽度
    //   var ratio = (clientx - videoleft) / videoWidth //当前鼠标移动的比率
    //   var videoduration = this.player.duration() //总时长
    //   this.player.currentTime(videoduration * ratio)
    //   this.$emit('videoratio', ratio)
    // },
  },
}
</script>
<style lang="less" scoped>
.preview-video{
   width: 100%;
}
.video-js,.video {
  width: 100%;
}
</style>